export const cryptoTickers = {
  3: 'dai',
  4: 'dai',
  5: 'eth',
  6: 'eth',
  USDC: 'USD Coin',
  DAI: 'DAI',
  ETH: 'Ethereum',
};
